import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import Identity from './identity';
import enforceRecaptcha, { RecaptchaMethod } from '../utils/enforceRecaptcha';
import { headers } from './constants';

/**
 * Request a password reset.  The API will create a nonce and trigger an event so that the nonce can be communicated to the user (via email, for example). The user can then call `resetPassword(nonce, newPassword)` to reset the password.
 *
 * @param userName
 *
 * @returns
 * A __Promise__ which resolves to `true` if successful.
 *
 * <details>
 * <summary>
 * On Success (resolves)
 * </summary>
 *
 * ```
 * true
 * ```
 * </details>
 *
 * <details>
 * <summary>
 * On error (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/User_Registration/resetPasswordRequest
 * ```
 * </details>
 */
export default function requestResetPassword(
  userName: string,
  recaptchaToken?: string
): Promise<boolean | APIErrorResponse> {
  return enforceRecaptcha(RecaptchaMethod.RESET_PASSWORD, recaptchaToken).then(() =>
    fetch(`${Identity.apiOrigin}/identity/public/v1/password/reset`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ userName, recaptchaToken })
    })
      .then(JSONResponseHandler)
      .then(json => {
        if (json.success) {
          return true;
        } else {
          throw json;
        }
      })
  );
}
